<template>
  <div class="boxbgcolor">
    <div class="left content-left">
      <AreaTree v-on:handleTreeClick="handleTreeClick"></AreaTree>
    </div>
    <div class="right content-right">
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for>车牌号:</label>
            <input
              v-model="search.plateNumber"
              class="form-control"
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group">
            <label for>车主姓名:</label>
            <input
              v-model="search.moncardsHostman"
              class="form-control"
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group">
            <label for="bdate">充值时间:</label>
            <el-date-picker
              v-model="search.chargeTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button @click="searchList" type="button" class="btn btn-primary" id="search_btn">查询</button>
            </span>
            <!--<button @click="clearSearch" type="button" class="btn btn-default">清空</button>-->

            <!-- <span class="refresh_btn"><Refresh @tableList="this.tableList"></Refresh></span> -->
          </div>
        </form>
      </div>
      <div class="list-right">
        <el-table
          :data="tableListData"
          border
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column show-overflow-tooltip label="车场名称">
            <template
              slot-scope="id"
            >{{id.row.parkingId?JSON.parse(id.row.parkingId).parkingName:''}}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="车牌号">
            <template
              slot-scope="scope"
            >{{scope.row.moncardsId?JSON.parse(scope.row.moncardsId).plateNumber:''}}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="车型">
            <template
              slot-scope="scope"
            >{{scope.row.moncardsId?JSON.parse(scope.row.moncardsId).carBrand:''}}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="车主姓名">
            <template
              slot-scope="scope"
            >{{scope.row.moncardsId?JSON.parse(scope.row.moncardsId).moncardsHostman:''}}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="支付方式" prop="payType"></el-table-column>
          <el-table-column show-overflow-tooltip label="充值金额" prop="realMoney"></el-table-column>
          <el-table-column show-overflow-tooltip label="原有效期" prop="ordExpiryDate"></el-table-column>
          <el-table-column show-overflow-tooltip label="现有效期" prop="nowExpiryDate"></el-table-column>
          <el-table-column show-overflow-tooltip label="充值时间" prop="chargeDate"></el-table-column>
          <!-- <el-table-column  show-overflow-tooltip label="续期时长" prop="longTime"></el-table-column> -->
          <!-- <el-table-column  show-overflow-tooltip
				label="操作员"
				prop="">
          </el-table-column>-->
        </el-table>
      </div>
    </div>

    <!-- <Page :pageSize="search.pageSize"></Page> -->
    <Page v-on:pagination="receivePaginationData"></Page>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import { fastenCarPayRecordAPI } from "@/api/url";

import Page from "../../commons/page.vue";

import AreaTree from "../../commons/parking/commons/areaTree.vue";

import Refresh from "../../commons/parking/commons/refresh.vue";

export default {
  data() {
    return {
      treeData: {
        parkingId: ""
      },
      styleObj: {
        "text-align": "center"
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB"
      },
      allFbType: [],
      search: {
        pageNumber: 1,
        pageSize: 10,
        chargeTime: "",
        moncardsHostman: "",
        plateNumber: ""
      },
      tableListData: [],
      defaultProps: {
        children: "children",
        label: "label"
      },

      formLabelWidth: "100px",

      dialogFormVisiblePhoto: false,
      allImgUrl: [],
      imgUrl: ""
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      if (!this.treeData.parkingId) {
        this.$message({
          type: "warning",
          message: "请选择停车场"
        });
        return;
      }
      this.tableList(this.search.pageNumber);
    },
    //点击树的节点展示相应数据
    handleTreeClick: function(node, data) {
      this.clearSearch();
      if (node.type == "parking") {
        this.treeData.parkingId = node.id;
        this.tableList(this.search.pageNumber);
      } else {
        this.treeData.parkingId = "";
        this.tableListData = [];
        // this.$message({
        // 	type:'warning',
        // 	message:'请选择停车场'
        // })
      }
    },
    tableList: function(curPage) {
      var _this = this;
      this.$get(fastenCarPayRecordAPI(), {
        page: curPage,
        limit: this.search.pageSize,
        parkingId: this.treeData.parkingId,
        plateNumber: this.search.plateNumber,
        moncardsHostman: this.search.moncardsHostman,
        beginTime: this.search.chargeTime ? this.search.chargeTime[0] : "",
        endTime: this.search.chargeTime ? this.search.chargeTime[1] : "",
        payStatus: 1
      }).then(data => {
        if (data.status != 200) return;
        //翻页
        var rows = data.data.rows;
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total
        };
        _this.getPage(pageObj);
        _this.tableListData = data.data.rows;
      });
    },
    searchList: function() {
      if (!this.treeData.parkingId) {
        this.$message({
          type: "warning",
          message: "请选择停车场"
        });
      }
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function() {
      this.search = {
        pageNumber: 1,
        pageSize: 10,
        chargeTime: "",
        moncardsHostman: "",
        plateNumber: ""
      };
    }
  },
  computed: {
    ...mapState({
      curIndex: state => state.page.curIndex,
      rowsCount: state => state.page.rowsCount
    })
  },
  components: {
    Page,
    AreaTree,
    Refresh
  },

  mounted: function() {
    // this.tableList(this.search.pageNumber)
  }
};
</script>

<style scoped>
.boxbgcolor {
  /*margin-top:20px;*/
}
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}

.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: #f9f9fb;
  /* height:130px;
		line-height:45px; */
  border-bottom: 10px solid #eff2f7;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
.demo-table-expand {
  font-size: 0;
}
.detail {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.detail ul {
  width: 50%;
}
.detail ul li {
  padding: 10px 0 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.detail ul li span {
  display: inline-block;
  width: 50%;
}
.detail ul li span:first-child {
  text-align: right;
  color: #aaa;
  font-weight: bold;
  width: 100px;
}
.detail ul li span:last-child {
  text-align: left;
  padding: 0 0 0 20px;
}
</style>
<style>
.ioRecord .el-select {
  width: 100px;
}
</style>